import moment from "moment";

function getAvailableRooms({
  room,
  excludeRatePlanId = null,
  fromdate,
  todate,
  bookingSidebar,
}) {
  if (!room || !room.maxcount) {
    console.error("Room data is undefined or missing 'maxcount'.");
    return 0;
  }

  let startDate = moment(fromdate, "DD-MM-YYYY");
  const endDate = moment(todate, "DD-MM-YYYY").subtract(1, "days");
  let minAvailableRooms = room.maxcount;

  while (startDate.isSameOrBefore(endDate)) {
    const dateStr = startDate.format("DD-MM-YYYY");
    let available = room.availability?.[dateStr] ?? room.maxcount;

    if (room.closeout && room.closeout[dateStr]?.all) {
      return 0;
    }

    const totalSelectedRooms = bookingSidebar.reduce((acc, plan) => {
      if (plan.roomId === room._id && plan.ratePlanId !== excludeRatePlanId) {
        return acc + (plan.selectedRooms || 0);
      }
      return acc;
    }, 0);

    available -= totalSelectedRooms;

    if (available < minAvailableRooms) {
      minAvailableRooms = available;
    }

    startDate = startDate.add(1, "days");
  }

  return minAvailableRooms > 0 ? minAvailableRooms : 0;
}

export { getAvailableRooms };
